<div class="mt-5 font-bold text-xl">{{'handover.statement' | translate}}</div>
<pre *ngIf="hasStatement else noStatementTemp" class="mt-3 whitespace-pre-wrap font-sans regulations">{{model?.statement}}</pre>
<ng-template #noStatementTemp>
  <div class="mt-3 mb-3">{{'handover.no-statement' | translate}}</div>
</ng-template>
